import { defineComponent as f, computed as o, openBlock as s, createElementBlock as c, createElementVNode as t, toDisplayString as d, createCommentVNode as h, normalizeStyle as n, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "fb88d310-ff7c-4f7c-bf94-ca0b5060be17" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), v = { mask: "url(#fb88d310-ff7c-4f7c-bf94-ca0b5060be17)" }, k = { key: 0 }, u = /* @__PURE__ */ p('<path fill="#ffda44" d="M199 0h32l32 256-32 256h-32l-32-256Z"></path><path fill="#496e2d" d="M167 0h32v512h-32l-32-256Z"></path><path fill="#0052b4" d="M231 0h281v512H231Z"></path><path fill="#d80027" d="M0 0h167v512H0Zm199 132-32 16 32 16a92 92 0 1 1 0 184l-32 16 32 16a124 124 0 0 0 0-248z"></path><path fill="#0052b4" d="M199 132a124 124 0 0 0 0 248v-32a92 92 0 1 1 0-184z"></path>', 5), g = { fill: "none" }, b = ["r"], N = /* @__PURE__ */ f({
  __name: "sami",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), r = o(() => 256 + e.strokeWidth / 2);
    return (x, w) => (s(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", v, [
        e.flagName ? (s(), c("title", k, d(e.flagName), 1)) : h("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, _));
  }
});
export {
  N as default
};
//# sourceMappingURL=sami-1299b828.js.map
